var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-layout-body',{attrs:{"title":"Alto custo - Gerenciamento de processo"}},[_c('rkm-layout-content',[_c('List')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }